import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@app/hooks/redux';

import { Formik, FormikHelpers } from 'formik';

import BoxesService from '@services/boxes';
import { getBoxes } from '@app/store/modules/boxes';
import { IBoxCreate } from '@app/store/modules/boxes/types';
import { Path } from '@app/const/paths';
import { Direction, ProfileFields } from '@app/const/consts';
import { displayErrorNotification } from '@app/utils/utils';
import { BUSINESS_BOX_FIELDS, BUSINESS_BOX_INITIAL_VALUES } from '../../consts';
import { BusinessBoxForm } from '../BusinessBoxForm/BusinessBoxForm';
import { businessBoxCreateValidationSchema } from '../../validationSchema';
import { IBusinessBox } from './types';
import { resetModal } from '@app/store/modules/modal';

const FIELDS = BUSINESS_BOX_FIELDS.filter(
  (val) => val.fieldName in BUSINESS_BOX_INITIAL_VALUES
);

export const BusinessBoxCreate = ({ onCloseModal }: IBusinessBox) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleCloseModal = () => {
    dispatch(resetModal());
    onCloseModal?.();
  };

  const handleSubmit = async (
    values: IBoxCreate,
    actions: FormikHelpers<IBoxCreate>
  ) => {
    await BoxesService.createBox(values)
      .then((result) => {
        dispatch(getBoxes()).unwrap();
        return result.data;
      })
      .then((boxOguid) => {
        const path = Path.ENVELOPES_BOX_OGUID.replace(
          ':boxOguid',
          boxOguid
        ).replace(':directionOrFolder', Direction.INCOMING);
        navigate(path);
        handleCloseModal();
      })
      .catch((err) => {
        displayErrorNotification(err);
        if (err.response.data.error === 'BOX_EMAIL_ALREADY_EXISTS') {
          actions.setFieldError(ProfileFields.EMAIL, err.response.data.message);
        }
      });
  };

  return (
    <>
      <header className='p-4 modal-header'>
        <h4 className='mb-0'>{t('boxes:title')}</h4>
      </header>
      <Formik
        initialValues={BUSINESS_BOX_INITIAL_VALUES}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
        validateOnBlur
        validationSchema={businessBoxCreateValidationSchema}
      >
        {(props) => (
          <BusinessBoxForm
            formikProps={props}
            onCloseModal={handleCloseModal}
            fields={FIELDS}
          />
        )}
      </Formik>
    </>
  );
};
